module.exports = __webpack_public_path__ + "static/media/logo.ee68ca65.png";